import React from 'react';
import cn from 'classnames';
import Modal from '../../../common/ui/Modal';

import styles from './styles.module.scss';

const DeviceReturnModal = ({ steps, isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      showSupportFooter={true}
      className={styles.baseModal}
    >
      <div className={styles.headerWrapper}>
        <h3 className={cn('h3', styles.title)}>Return Status</h3>
      </div>
      <ul className={styles.steps}>
        {steps.map((item, index) => {
          return (
            <li key={index} className={styles[item.status]}>
              {item.label}
            </li>
          );
        })}
      </ul>
    </Modal>
  );
};

export default DeviceReturnModal;
